import React from "react";
import { shouldShowBottomNav } from "../utils/bottomNavRoutes";

function BootCard({ height }) {
  return (
    <div
      aria-hidden="true"
      style={{
        minHeight: height,
        borderRadius: 20,
        border: "1px solid var(--border-subtle)",
        background: "linear-gradient(90deg, var(--skeleton-base) 25%, var(--skeleton-highlight) 50%, var(--skeleton-base) 75%)",
        backgroundSize: "220px 100%",
        boxShadow: "var(--shadow-card)",
        position: "relative",
        overflow: "hidden",
        animation: "boot-shimmer 1.35s linear infinite",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(90deg, transparent, color-mix(in srgb, var(--interactive-fg) 14%, transparent), transparent)",
          transform: "translateX(-100%)",
          animation: "boot-sheen 1.35s linear infinite",
        }}
      />
    </div>
  );
}

export default function AppBootScreen({ pathname = "/", showBottomNavPlaceholder = true }) {
  const path = String(pathname || "/");
  const showHeader = !path.startsWith("/wallet") && path !== "/claim" && path !== "/referral";
  const showBottomNav = shouldShowBottomNav(path);
  const compact = path === "/mechanics";
  const reserveBottomNav = showBottomNavPlaceholder && showBottomNav;

  return (
    <>
      <style>
        {`
          @keyframes boot-shimmer {
            from { background-position: -220px 0; }
            to { background-position: 220px 0; }
          }

          @keyframes boot-sheen {
            from { transform: translateX(-100%); }
            to { transform: translateX(100%); }
          }
        `}
      </style>

      <div
        style={{
          minHeight: "100dvh",
          background: "var(--page-bg)",
        }}
      >
        {showHeader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px 12px 0 12px",
              boxSizing: "border-box",
            }}
          >
            <div
              aria-hidden="true"
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "linear-gradient(90deg, var(--skeleton-base) 25%, var(--skeleton-highlight) 50%, var(--skeleton-base) 75%)",
                backgroundSize: "180px 100%",
                animation: "boot-shimmer 1.35s linear infinite",
                boxShadow: "var(--shadow-control)",
              }}
            />
          </div>
        ) : null}

        <div
          style={{
            width: "min(100%, 1100px)",
            margin: "0 auto",
            padding: reserveBottomNav
              ? (showHeader ? "12px 10px var(--bottom-nav-clearance)" : "16px 10px var(--bottom-nav-clearance)")
              : (showHeader ? "12px 10px 24px" : "16px 10px 24px"),
            boxSizing: "border-box",
            display: "grid",
            gap: 18,
          }}
        >
          {compact ? (
            <>
              <BootCard height={120} />
              <BootCard height={160} />
              <BootCard height={220} />
            </>
          ) : (
            <>
              <BootCard height={208} />
              <BootCard height={392} />
            </>
          )}
        </div>

        {reserveBottomNav ? (
          <div
            aria-hidden="true"
            style={{
              position: "fixed",
              left: "max(6px, env(safe-area-inset-left, 0px))",
              right: "max(6px, env(safe-area-inset-right, 0px))",
              bottom: "calc(var(--app-footer-offset) + env(safe-area-inset-bottom, 0px))",
              width: "auto",
              maxWidth: 560,
              minHeight: "var(--app-footer-height)",
              marginInline: "auto",
              background: "var(--surface-bg-glass)",
              border: "1px solid var(--border-control)",
              boxShadow: "var(--shadow-elevated)",
              backdropFilter: "blur(14px)",
              borderRadius: 20,
              padding: 6,
              boxSizing: "border-box",
              display: "grid",
              gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
              gap: 2,
              zIndex: 99,
            }}
          >
            {Array.from({ length: 5 }).map((_, idx) => (
              <div
                key={idx}
                style={{
                  minWidth: 0,
                  minHeight: 56,
                  borderRadius: 14,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 5,
                  background: "var(--control-bg)",
                }}
              >
                <div
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: 7,
                    background: "linear-gradient(90deg, var(--skeleton-base), var(--skeleton-highlight), var(--skeleton-base))",
                    backgroundSize: "120px 100%",
                    animation: "boot-shimmer 1.35s linear infinite",
                  }}
                />
                <div
                  style={{
                    width: idx === 0 ? 34 : 40,
                    maxWidth: "72%",
                    height: 7,
                    borderRadius: 999,
                    background: "var(--skeleton-base)",
                  }}
                />
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </>
  );
}
